import ExplorCourses from "./ExploreCourses"
import Testimonial from "./Testimonial"
import LatestNews from "./LatestNews"

export default function Main1() {
    return (
        <>
            <ExplorCourses />
            <Testimonial />
            <LatestNews />
        </>
    )
}